module.exports = __webpack_public_path__ + "img/logitricks_logo_ligne.d804d9ca.png";